import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { DealConstructionItem } from '~/models/DealConstructionItem';
import { generatePath } from '~/utils/generatePath';

export const useDealConstructionItems = (): SwrReturnType<
  DealConstructionItem[]
> => {
  const { data, mutate, error, isLoading } = useSWR<DealConstructionItem[]>(
    generatePath('/deal_construction_items')
  );
  return {
    data: data ?? null,
    mutate,
    isLoading,
    error
  };
};
